module.exports = __webpack_public_path__ + "static/media/PublishedFeedbacks_preview.5fdcc5ec.png";